import {
    FETCH_SELLERS,
    FETCH_SELLERS_SUCCESS,
    FETCH_SELLERS_FAIL,
    SHOW_SELLER_SUCCESS,
    CREATE_SELLER_SUCCESS,
    CREATE_EXIT_AUDIT_SELLER_SUCCESS,
    UPDATE_SELLER_SUCCESS,
    SCRAPE_SELLER_DATA_SUCCESS,
    GENERATE_SALES_DECK_SUCCESS,
    SEND_CONFIDENTIALITY_AGREEMENT_SUCCESS,
    SEND_PRE_MEETING_DISCOVERY_EMAIL_SUCCESS,
    SEND_VALUATION_REQUEST_EMAIL_SUCCESS,
    SYNC_GOOGLE_DRIVE_SUCCESS,
    GENERATE_EXIT_NAVIGATOR_SUCCESS,
    FETCH_SELLER_BUYERS,
    FETCH_SELLER_BUYERS_SUCCESS,
    FETCH_ALL_SELLER_BUYERS_SUCCESS,
    SELLER_DEAL_STUDIO_SYNC_SUCCESS
  } from '../actions/types';
  
  const INITIAL_STATE = {
    sellers: null,
    seller: null,
    pagination: null,
    buyerPagination: null,
    pipelineBuyers: null,
    isLoading: false
  };
  
  export default function sellerReducer (state=INITIAL_STATE, action) {

    switch (action.type) {
      case FETCH_SELLERS:
        return { ...state, isLoading: true };
      case FETCH_SELLERS_SUCCESS:
        return { ...state, sellers: action.payload.sellers, pagination: action.payload.pagination, isLoading: false };
      case FETCH_SELLERS_FAIL:
        return { ...state, isLoading: false };
      case SHOW_SELLER_SUCCESS:
        return { ...state, seller: action.payload.seller };
      case FETCH_SELLER_BUYERS:
        return { ...state, isLoading: true };
      case FETCH_SELLER_BUYERS_SUCCESS:
        return { ...state, seller: action.payload.seller, buyerPagination: action.payload.pagination, isLoading: false };
      case FETCH_ALL_SELLER_BUYERS_SUCCESS:
        return { ...state, seller: action.payload.seller, pipelineBuyers: action.payload.buyers };
      case CREATE_EXIT_AUDIT_SELLER_SUCCESS:
        return { ...state, seller: action.payload.seller };
      case SCRAPE_SELLER_DATA_SUCCESS:
        return { ...state, seller: action.payload.seller };
      case CREATE_SELLER_SUCCESS:
        return { ...state, seller: action.payload.seller };
      case UPDATE_SELLER_SUCCESS:
        return { 
          ...state, 
          seller: {
            ...action.payload.seller,
            // Set buyers to null to trigger loading state, will be refetched via fetchSellerBuyers
            buyers: null
          }
        };
      case GENERATE_SALES_DECK_SUCCESS:
        return { ...state, seller: action.payload.seller };
      case SEND_CONFIDENTIALITY_AGREEMENT_SUCCESS:
        return { ...state, seller: action.payload.seller };
      case SEND_PRE_MEETING_DISCOVERY_EMAIL_SUCCESS:
        return { ...state, seller: action.payload.seller };
      case SEND_VALUATION_REQUEST_EMAIL_SUCCESS:
        return { ...state, seller: action.payload.seller };
      case SYNC_GOOGLE_DRIVE_SUCCESS:
        return { ...state, seller: action.payload.seller };
      case GENERATE_EXIT_NAVIGATOR_SUCCESS:
        return { ...state, seller: action.payload.seller };
      case SELLER_DEAL_STUDIO_SYNC_SUCCESS:
        return { ...state, seller: action.payload.seller };
      default:
        return state;
    }
  };
